(() => {
  window.LPMPreviewProfiles = window.LPMPreviewProfiles || {};

  /*
   * =========================================================
   * CRÉOLES CHARMS — 3 CAS DE FIGURE
   *
   * 1. single
   *    Une seule créole + charms à l’unité
   *
   * 2. pair_identical
   *    Paire de créoles + chaque modèle choisi en ×2
   *
   * 3. pair_different
   *    Paire de créoles + 2 premiers modèles différents ×1
   *    Les modèles suivants restent des extras ×1
   *
   * IMPORTANT :
   * - pair_different desktop, position 1 validée :
   *   { x: 145, y: 215, r: 0 }
   * - toutes les autres coordonnées sont des bases de calibration.
   * =========================================================
   */

  /* =========================================================
     CAS 1 — UNE SEULE CRÉOLE
     ========================================================= */

  const creolesSingleDesktopSlots = {
    0: [],

    1: [
      { x: 255, y: 215, r: 0 }
    ],

    2: [
      { x: 245, y: 350, r: 0 },
      { x: 255, y: 215, r: 0 }
    ],

    3: [
      { x: 185, y: 350, r: 0 },
      { x: 345, y: 350, r: 0 },
      { x: 255, y: 215, r: 0 }
    ],

    4: [
      { x: 145, y: 350, r: 0 },
      { x: 265, y: 350, r: 0 },
      { x: 385, y: 350, r: 0 },
      { x: 255, y: 215, r: 0 }
    ],

    5: [
      { x: 25, y: 350, r: 0 },
      { x: 145, y: 350, r: 0 },
      { x: 265, y: 350, r: 0 },
      { x: 385, y: 350, r: 0 },
      { x: 255, y: 215, r: 0 }
    ]
  };

 const creolesSingleMobileSlots = {
  0: [],

  1: [
    { x: 110, y: 137, r: 0 }
  ],

  2: [
    { x: 112, y: 250, r: 0 },
    { x: 110, y: 137, r: 0 }
  ],

  3: [
    { x: 60, y: 250, r: 0 },
    { x: 160, y: 250, r: 0 },
    { x: 110, y: 137, r: 0 }
  ],

  4: [
    { x: 0, y: 250, r: 0 },
    { x: 112, y: 250, r: 0 },
    { x: 225, y: 250, r: 0 },
    { x: 110, y: 137, r: 0 }
  ],

  5: [
    { x: 0, y: 250, r: 0 },
    { x: 75, y: 250, r: 0 },
    { x: 150, y: 250, r: 0 },
    { x: 225, y: 250, r: 0 },
    { x: 110, y: 137, r: 0 }
  ]
};


  /* =========================================================
     CAS 2 — PAIRE + CHARMS IDENTIQUES
     Chaque entrée = 1 MODÈLE sélectionné,
     avec 2 positions physiques : left + right.
     ========================================================= */

  const creolesPairIdenticalDesktopSlots = {
    0: [],

    1: [
      {
        left:  { x: 145, y: 215, r: 0 },
        right: { x: 350, y: 215, r: 0 }
      }
    ],

    2: [
      {
        left:  { x: 30, y: 380, r: 0 },
        right: { x: 80, y: 380, r: 0 }
      },
      {
        left:  { x: 145, y: 215, r: 0 },
        right: { x: 350, y: 215, r: 0 }
      }
    ],

    3: [
      {
        left:  { x: 30, y: 380, r: 0 },
        right: { x: 80, y: 380, r: 0 }
      },
      {
        left:  { x: 170, y: 380, r: 0 },
        right: { x: 220, y: 380, r: 0 }
      },
      {
        left:  { x: 145, y: 215, r: 0 },
        right: { x: 350, y: 215, r: 0 }
      }
    ],

    4: [
      {
        left:  { x: 30, y: 380, r: 0 },
        right: { x: 80, y: 380, r: 0 }
      },
      {
        left:  { x: 170, y: 380, r: 0 },
        right: { x: 220, y: 380, r: 0 }
      },
      {
        left:  { x: 310, y: 380, r: 0 },
        right: { x: 360, y: 380, r: 0 }
      },  
      {
        left:  { x: 145, y: 215, r: 0 },
        right: { x: 350, y: 215, r: 0 }
      }
    ],

    5: [
      {
        left:  { x: 30, y: 380, r: 0 },
        right: { x: 80, y: 380, r: 0 }
      },
      {
        left:  { x: 170, y: 380, r: 0 },
        right: { x: 220, y: 380, r: 0 }
      },
      {
        left:  { x: 310, y: 380, r: 0 },
        right: { x: 360, y: 380, r: 0 }
      },  
      {
        left:  { x: 450, y: 380, r: 0 },
        right: { x: 500, y: 380, r: 0 }
      },
     {
        left:  { x: 145, y: 215, r: 0 },
        right: { x: 350, y: 215, r: 0 }
      }
    ]
  };

  const creolesPairIdenticalMobileSlots = {
  0: [],

  1: [
    {
      left:  { x: 40, y: 137, r: 0 },
      right: { x: 170, y: 137, r: 0 }
    }
  ],

  2: [
    {
      left:  { x: 112, y: 250, r: 0 },
      right: { x: 150, y: 250, r: 0 }
    },
    {
      left:  { x: 40, y: 137, r: 0 },
      right: { x: 170, y: 137, r: 0 }
    }
  ],

  3: [
    {
      left:  { x: 60, y: 250, r: 0 },
      right: { x: 98, y: 250, r: 0 }
    },
    {
      left:  { x: 160, y: 250, r: 0 },
      right: { x: 198, y: 250, r: 0 }
    },
    {
      left:  { x: 40, y: 137, r: 0 },
      right: { x: 170, y: 137, r: 0 }
    }
  ],

  4: [
    {
      left:  { x: 0, y: 250, r: 0 },
      right: { x: 38, y: 250, r: 0 }
    },
    {
      left:  { x: 112, y: 250, r: 0 },
      right: { x: 150, y: 250, r: 0 }
    },
    {
      left:  { x: 225, y: 250, r: 0 },
      right: { x: 263, y: 250, r: 0 }
    },
    {
      left:  { x: 40, y: 137, r: 0 },
      right: { x: 170, y: 137, r: 0 }
    }
  ],

  5: [
    {
      left:  { x: 0, y: 250, r: 0 },
      right: { x: 38, y: 250, r: 0 }
    },
    {
      left:  { x: 75, y: 250, r: 0 },
      right: { x: 113, y: 250, r: 0 }
    },
    {
      left:  { x: 150, y: 250, r: 0 },
      right: { x: 188, y: 250, r: 0 }
    },
    {
      left:  { x: 225, y: 250, r: 0 },
      right: { x: 263, y: 250, r: 0 }
    },
    {
      left:  { x: 40, y: 137, r: 0 },
      right: { x: 170, y: 137, r: 0 }
    }
  ]
};


  /* =========================================================
     CAS 3 — PAIRE + CHARMS DIFFÉRENTS
     Position 1 desktop VALIDÉE par Maroo.
     Le cas 1 reste utile pendant la sélection du 2e modèle,
     même si l’ajout panier est bloqué tant qu’il n’y en a pas 2.
     ========================================================= */

  const creolesPairDifferentDesktopSlots = {
    0: [],

    1: [
      { x: 145, y: 215, r: 0 }
    ],

    2: [
      { x: 145, y: 215, r: 0 },
      { x: 350, y: 215, r: 0 }
    ],

    3: [
      { x: 80, y: 380, r: 0 },
      { x: 145, y: 215, r: 0 },
      { x: 350, y: 215, r: 0 }
    ],

    4: [
      { x: 80, y: 380, r: 0 },
      { x: 180, y: 380, r: 0 },
      { x: 145, y: 215, r: 0 },
      { x: 350, y: 215, r: 0 }
      
      
    ],

    5: [
      { x: 80, y: 380, r: 0 },
      { x: 180, y: 380, r: 0 },
      { x: 280, y: 380, r: 0 },
      { x: 145, y: 215, r: 0 },
      { x: 350, y: 215, r: 0 }
    ]
  };

  const creolesPairDifferentMobileSlots = {
    0: [],

    1: [
      { x: 40, y: 137, r: 0 }
    ],

    2: [
      { x: 40, y: 137, r: 0 },
      { x: 170, y: 137, r: 0 }
    ],

    3: [
      { x: 136, y: 255, r: 0 },
      { x: 40, y: 137, r: 0 },
      { x: 170, y: 137, r: 0 }
    ],

    4: [
      { x: 95, y: 255, r: 0 },
      { x: 177, y: 255, r: 0 },
      { x: 40, y: 137, r: 0 },
      { x: 170, y: 137, r: 0 }
    ],

    5: [
      { x: 55, y: 255, r: 0 },
      { x: 136, y: 255, r: 0 },
      { x: 217, y: 255, r: 0 },
      { x: 40, y: 137, r: 0 },
      { x: 170, y: 137, r: 0 }
    ]
  };


  /* =========================================================
     PROFIL
     Fallback = paire identique (état par défaut du builder)
     ========================================================= */

  window.LPMPreviewProfiles["creoles-charms"] = {
    desktop: creolesPairIdenticalDesktopSlots,
    mobile: creolesPairIdenticalMobileSlots,

    charmWidthDesktop: 150,
    charmWidthMobile: 115,
    mobileBreakpoint: 749,

    layouts: {
      single: {
        renderer: "single-models",
        desktop: creolesSingleDesktopSlots,
        mobile: creolesSingleMobileSlots
      },

      pair_identical: {
        renderer: "paired-models",
        desktop: creolesPairIdenticalDesktopSlots,
        mobile: creolesPairIdenticalMobileSlots
      },

      pair_different: {
        renderer: "single-models",
        desktop: creolesPairDifferentDesktopSlots,
        mobile: creolesPairDifferentMobileSlots
      }
    }
  };
})();
